(function () {
  if (window.__llCartFeedbackInstalled) return;
  window.__llCartFeedbackInstalled = true;

  const originalFetch = window.fetch;
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  function getRoot() {
    return (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/'
    );
  }

  function isCartAddUrl(input) {
    let url = '';

    if (typeof input === 'string') {
      url = input;
    } else if (input && input.url) {
      url = input.url;
    }

    return /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);
  }

  async function getCart() {
    const response = await originalFetch.call(
      window,
      getRoot() + 'cart.js',
      {
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('A kosár lekérése sikertelen.');
    }

    return response.json();
  }

  function updateCartBadge(cart) {
    const cartIcons = document.querySelectorAll(
      '#cart-icon-bubble'
    );

    cartIcons.forEach(function (cartIcon) {
      let bubble = cartIcon.querySelector('.cart-count-bubble');

      if (!bubble && cart.item_count > 0) {
        bubble = document.createElement('span');
        bubble.className = 'cart-count-bubble';

        bubble.innerHTML = `
          <span aria-hidden="true">${cart.item_count}</span>
          <span class="visually-hidden">
            ${cart.item_count} termék a kosárban
          </span>
        `;

        cartIcon.appendChild(bubble);
      }

      if (!bubble) return;

      if (cart.item_count === 0) {
        bubble.classList.add('hidden');
        return;
      }

      bubble.classList.remove('hidden');
      bubble.removeAttribute('hidden');

      bubble.classList.toggle(
        'cart-count-bubble--dot',
        cart.item_count >= 100
      );

      let visibleCount =
        bubble.querySelector('span[aria-hidden="true"]');

      if (cart.item_count < 100) {
        if (!visibleCount) {
          visibleCount = document.createElement('span');
          visibleCount.setAttribute('aria-hidden', 'true');
          bubble.prepend(visibleCount);
        }

        visibleCount.textContent = cart.item_count;
      } else if (visibleCount) {
        visibleCount.remove();
      }

      const hiddenCount =
        bubble.querySelector('.visually-hidden');

      if (hiddenCount) {
        hiddenCount.textContent =
          `${cart.item_count} termék a kosárban`;
      }
    });
  }

  function showCartSuccess() {
    let message =
      document.getElementById('ll-cart-success-message');

    if (!message) {
      message = document.createElement('div');
      message.id = 'll-cart-success-message';

      message.innerHTML = `
        <div class="ll-cart-success-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 12.5l4.2 4.2L19 7"></path>
          </svg>
        </div>

        <div class="ll-cart-success-text">
          <strong>Kosárba helyezve</strong>
          <span>A terméket sikeresen hozzáadtuk a kosárhoz.</span>
        </div>
      `;

      Object.assign(message.style, {
        position: 'fixed',
        top: '24px',
        right: '24px',
        zIndex: '999999',
        width: 'calc(100% - 48px)',
        maxWidth: '380px',
        display: 'flex',
        alignItems: 'center',
        gap: '13px',
        padding: '16px 18px',
        background: '#465C5B',
        color: '#ffffff',
        borderRadius: '10px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.18)',
        opacity: '0',
        transform: 'translateY(-12px)',
        transition:
          'opacity 0.25s ease, transform 0.25s ease',
        pointerEvents: 'none'
      });

      const icon =
        message.querySelector('.ll-cart-success-icon');

      Object.assign(icon.style, {
        width: '32px',
        height: '32px',
        minWidth: '32px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.16)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      });

      const svg = icon.querySelector('svg');

      Object.assign(svg.style, {
        width: '19px',
        height: '19px',
        fill: 'none',
        stroke: '#ffffff',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      });

      const text =
        message.querySelector('.ll-cart-success-text');

      Object.assign(text.style, {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px'
      });

      Object.assign(
        text.querySelector('strong').style,
        {
          fontSize: '15px',
          fontWeight: '600',
          lineHeight: '1.3'
        }
      );

      Object.assign(
        text.querySelector('span').style,
        {
          fontSize: '13px',
          lineHeight: '1.4',
          opacity: '0.9'
        }
      );

      document.body.appendChild(message);
    }

    requestAnimationFrame(function () {
      message.style.opacity = '1';
      message.style.transform = 'translateY(0)';
    });

    clearTimeout(window.llCartMessageTimeout);

    window.llCartMessageTimeout =
      setTimeout(function () {
        message.style.opacity = '0';
        message.style.transform = 'translateY(-12px)';
      }, 2800);
  }

  async function cartWasUpdated(showMessage) {
    try {
      const cart = await getCart();

      updateCartBadge(cart);

      if (showMessage) {
        showCartSuccess();
      }
    } catch (error) {
      console.error(
        'Kosár frissítési hiba:',
        error
      );
    }
  }

  /*
   * FIGYELJÜK A FETCH-ES KOSÁRBA HELYEZÉST
   */
  window.fetch = async function () {
    const args = Array.from(arguments);
    const isAdd = isCartAddUrl(args[0]);

    const response =
      await originalFetch.apply(window, args);

    if (isAdd && response.ok) {
      setTimeout(function () {
        cartWasUpdated(true);
      }, 100);
    }

    return response;
  };

  /*
   * FIGYELJÜK AZ XHR-ES KOSÁRBA HELYEZÉST IS
   */
  XMLHttpRequest.prototype.open = function (
    method,
    url
  ) {
    this.__llCartAddRequest =
      typeof url === 'string' &&
      /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);

    return originalXHROpen.apply(
      this,
      arguments
    );
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__llCartAddRequest) {
      this.addEventListener(
        'loadend',
        function () {
          if (
            this.status >= 200 &&
            this.status < 300
          ) {
            setTimeout(function () {
              cartWasUpdated(true);
            }, 100);
          }
        }
      );
    }

    return originalXHRSend.apply(
      this,
      arguments
    );
  };

  /*
   * INDULÁSKOR A KOSÁRSZÁMLÁLÓ HELYREÁLLÍTÁSA
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        cartWasUpdated(false);
      }
    );
  } else {
    cartWasUpdated(false);
  }
})();